import onComposeLifecycleEvent from 'owa-mail-compose-store/lib/actions/onComposeLifecycleEvent';
import { ComposeLifecycleEvent } from 'owa-mail-compose-store';
import { setShowListPane, setShowReadingPane } from 'owa-mail-layout';
import { isReadingPanePositionOff } from 'owa-mail-layout/lib/selectors/readingPanePosition';
import { orchestrator } from 'satcheljs';

/**
 * Decides whether to hide RP after full compose closes from primary tab
 */
export const onCloseFullComposeOrchestrator = orchestrator(
    onComposeLifecycleEvent,
    actionMessage => {
        if (actionMessage.event == ComposeLifecycleEvent.CloseFullComposeFromPrimaryTab) {
            setShowListPane(true /* showListPane */);
            setShowReadingPane(!isReadingPanePositionOff());
        }
    }
);
